import React, { useState } from "react";
import {
  Button,
  Modal,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import RemoteComponent from "../components/RemoteComponent";
import InstructionComponent from "../components/InstructionComponent"; // Import InstructionComponent
import ProgressBarComponent from "../components/ProgressBar"; // Import ProgressBarComponent
import "../App.css";
import { TfiAndroid } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";
import { useBluetooth } from "../BluetoothContext";
import NumberPad from "../components/numbers";
import instructions from "../components/instructions.png";

const Setup: React.FC = () => {
  const [counter, setCounter] = useState(0);
  const [isSetupStarted, setSetupStarted] = useState(false); // Track if setup started
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalCallback, setModalCallback] = useState<
    (response: string) => void
  >(() => () => {});
  const [showPopup, setShowPopup] = useState(false);
  const [isImageOverlayVisible, setImageOverlayVisible] = useState(false); // Control overlay visibility

  const { startSetup, checkTestComplete, sendSignalResponse } = useBluetooth();
  const navigate = useNavigate();

  const handleSetup = async () => {
    setSetupStarted(true); // Mark setup as started
    await startSetup();

    while (counter < 15) {
      const isTestComplete = await checkTestComplete();

      if (isTestComplete) {
        const userResponse = await new Promise((resolve) => {
          setModalCallback(() => resolve);
          setModalVisible(true);
        });

        setModalVisible(false);
        await sendSignalResponse(userResponse as string);

        if (userResponse === "y") {
          console.log("Signal confirmed, moving to the next step.");
          setCounter((prev) => prev + 1);
        } else {
          console.log("Signal failed, retrying...");
        }
      } else {
        console.log("Waiting for the signal...");
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    setShowPopup(true);
  };

  const handleReturnHome = () => navigate("/");

  return (
    <div className="setup-background">
      <Container
        className="d-flex flex-column justify-content-between align-items-center"
        style={{ minHeight: "100vh", textAlign: "center" }}
      >
        {/* Title Section */}
        <Row className="w-100">
          <Col>
            <h1 className="h1">Setup Remote</h1>
            <span
              className="info-icon fs-3 ms-3"
              role="img"
              aria-label="info"
              onClick={() => setImageOverlayVisible(true)} // Show overlay on click
              style={{
                cursor: "pointer",
                color: "black", // Set text color to white
              }}
            >
              Instructions ℹ️
            </span>
          </Col>
        </Row>

        {/* Remote Section */}
        <Row className="w-100 d-flex align-items-center justify-content-center gap-3">
          <Col xs="auto">
            <RemoteComponent counter={counter} />
          </Col>
          <Col xs="auto">
            <NumberPad counter={counter} />
          </Col>
        </Row>

        {/* Setup Section */}
        <Col>
          {!isSetupStarted ? (
            <Button
              variant="primary"
              onClick={handleSetup}
              className="d-flex align-items-center justify-content-center w-auto py-3 mt-4"
            >
              <TfiAndroid className="me-2" />
              Start Setup
            </Button>
          ) : (
            <div>
              <InstructionComponent count={counter} />
              <ProgressBarComponent currentStep={counter} totalSteps={15} />
            </div>
          )}

          {/* Confirmation */}
          <Modal
            show={isModalVisible}
            onHide={() => modalCallback("no")}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Signal Test</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Was the signal successful?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => modalCallback("n")}>
                No
              </Button>
              <Button variant="success" onClick={() => modalCallback("y")}>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Container>

      {/* Image Overlay */}
      <Modal
        show={isImageOverlayVisible}
        onHide={() => setImageOverlayVisible(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={instructions}
            alt="Instructions"
            style={{ width: "100%", height: "auto" }}
          />
        </Modal.Body>
      </Modal>

      {/* Completion Popup */}
      <Modal show={showPopup} onHide={handleReturnHome}>
        <Modal.Header closeButton>
          <Modal.Title>Setup Complete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>Congratulations, your remote has now been set up!</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleReturnHome}>
            Return Home
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Setup;
